import styled from '@xstyled/styled-components';
import Speaker from '~/training/onboarding/assets/videoicon.svg';

export const VideoIcon = styled(Speaker)`
  max-width: 33px;
  max-height: 33px;
  fill: black;
  width: 33px;
  height: 33px;
`;
